// import {FC} from 'react'

// const PatientNameCell = (props: any) => {
//   return (
//     <div className='d-flex ms-5 '>
//       <span className='text-black fw-bold fs-7 '>
//         {props?.tableProps?.firstName} {props?.tableProps?.lastName}
//       </span>
//     </div>
//   )
// }

// export {PatientNameCell}

/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_ePulse/assets/ts/components'
import {KTSVG} from '../../../../../../../../_ePulse/helpers'
import {Link, useNavigate} from 'react-router-dom'

import {checkPermission} from '../../../../../../../App'
import useLocalStorageFetch from '../../../../../../../../hooks/localStorageFetch'
import {useDispatch} from 'react-redux'
import {actionsUsers} from '../../../../../../../../setup/redux/rootReducer'
import {EditPatientModal} from '../../../../importPatient/modals/EditPatient'
import {EditTodayPatientModal} from '../../../modals/EditPatient'

const PatientNameCell = (props: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [editModal, setEditModal] = useState(false)
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const {role} = useLocalStorageFetch()

  const onHandleclick = (appointment: any) => {
    // navigate(`/${role}/rx_template/rx-on-fly`, {
    //   state: {
    //     appointmentId: appointment.id,
    //     patientData: {
    //       userId: appointment.patientId,
    //       firstName: appointment.firstName,
    //       lastName: appointment.lastName,
    //     },
    //   },
    // })

    //New user flow
    navigate(`/${role}/patient-details`, {
      state: {
        appointmentId: appointment.id,
        patientData: {
          userId: appointment.patientId,
          firstName: appointment.firstName,
          lastName: appointment.lastName,
          profilePhoto: appointment.profilePhoto,
          dob: appointment.dob,
          mobileNumber: appointment.mobileNumber,
        },
      },
    })
  }

  const appointment = props.tableProps
  const closeModal = () => {
    setEditModal(false)
    props.refetch()
  }

  return (
    <div className='d-flex ms-5'>
      {editModal && (
        <EditTodayPatientModal
          modalState={editModal}
          closeModal={() => closeModal()}
          idToEdit={props?.tableProps?.patientRoleId}
        />
      )}
      <div className='d-flex flex-row col align-items-center '>
        <span className='text-black fw-bold fs-7 '>
          {props?.tableProps?.firstName} {props?.tableProps?.lastName}
        </span>
        {checkPermission('editBusinessPatient') && (
          <button
            onClick={() => {
              setEditModal(true)
            }}
            className='border-0 bg-white'
          >
            <KTSVG
              path='/media/ePulse/edit_icon.svg'
              className='m-0'
              svgClassName='mh-15px mw-15px'
            />
          </button>
        )}
        {/* <div className='d-flex flex-row align-items-center '>
          {!appointment.isPrescriptionSent ? (
            checkPermission('storeClinicRxPrescriptionData') && (
              <button
                onClick={() => {
                  dispatch(actionsUsers.updateSelectedPatient({}))
                  onHandleclick(appointment)
                  localStorage.setItem('todayRXEdit', 'NO')
                }}
                className='menu-link text-dark border-0 bg-white '
              >
                <span className='text-black fw-bold fs-7 '>
                  {props?.tableProps?.firstName} {props?.tableProps?.lastName}
                </span>
              </button>
            )
          ) : (
            <span className='text-black fw-bold fs-7 '>
              {props?.tableProps?.firstName} {props?.tableProps?.lastName}
            </span>
          )}
        </div> */}
      </div>
    </div>
  )
}

export {PatientNameCell}
